import LabelIcon from 'components/icons/label';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: 100%;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
`;

export const BadgeContainer = styled.div<{ clickable?: boolean }>`
    display: inline-flex;
    cursor: ${(props) => (props.clickable ? 'pointer' : 'default')};
    transition: ${(props) => (props.clickable ? 'transform 0.1s ease-in-out' : 'none')};
    &:hover {
        transform: ${(props) => (props.clickable ? 'scale(1.03)' : 'none')};
    }
`;

export const Dropdown = styled.div`
    width: 260px;
    max-height: 300px;
    border: solid 1px ${(props) => props.theme.rainbow.palette.border.divider};
    border-radius: 0.875rem;
    background: ${(props) => props.theme.rainbow.palette.background.main};
    box-shadow: ${(props) => props.theme.rainbow.shadows.shadow_2};
    transition: all 0.1s linear;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding: 1rem;
`;

export const DropdownHeader = styled.div`
    font-size: 0.875rem;
    font-weight: 600;
    color: ${(props) => props.theme.rainbow.palette.text.main};
    margin-bottom: 0.75rem;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid ${(props) => props.theme.rainbow.palette.border.divider};
`;

export const BadgesGrid = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.50rem;
    width: 100%;
`;

export const TagIcon = styled(LabelIcon)`
    width: 1rem !important;
    height: 1rem !important;
    margin-right: 0.25rem;
    margin-bottom: 1px;
    flex-shrink: 0;
    vertical-align: middle;
`;
